import SpecialTitle, {
  ISpecialTitleProps,
} from "@/components/common/SpecialTitle";
import classnames from "classnames";
import React from "react";
import RankLoading from "./Rankloading";

interface IProps {
  title: React.ReactNode;
  titleSize?: ISpecialTitleProps["size"];
  loading?: boolean;
  className?: string;
  children: React.ReactNode;
}

const RankWrap = React.forwardRef<HTMLOListElement, IProps>(
  (
    { title, titleSize = "normal", loading = false, className = "", children },
    ref,
  ) => {
    const mergeClassName = classnames("rank", className);
    const bk = typeof title === "string" ? title : "排行榜";

    return (
      <div className={mergeClassName} data-bk={bk}>
        <SpecialTitle size={titleSize}>{title}</SpecialTitle>
        <ol ref={ref} className="rank__list">
          {loading ? <RankLoading /> : children}
        </ol>
      </div>
    );
  },
);
RankWrap.displayName = "RankWrap";
export default RankWrap;
